<template>
  <header>
    <NavbarMain />
  </header>
  <div class="h-100 content-background-color">
    <ReloadPWA />
    <div
      class="content d-flex flex-column flex-column-fluid content-background-color"
      id="kt_content"
    >
      <div class="d-flex flex-column-fluid">
        <div class="container">
          <div class="row">
            <div class="col-12 z-index-2">
              <div class="lv-nav-wrap mb-24">
                <div class="card-body menu-container">
                  <ul
                    class="nav nav-pills nav-info m-0 p-0 d-flex flex-nowrap overflow-auto"
                  >
                    <li
                      class="nav-item d-flex col-sm flex-grow-1 flex-shrink-0 mb-lg"
                      v-for="(item, index) in menuList"
                      :key="index"
                    >
                      <RouterLink
                        class="nav-link border-lg d-flex flex-grow-1 flex-column justify-content-center align-items-center"
                        active-class="active"
                        exact="true"
                        :to="{ name: item.name }"
                      >
                        <div class="icon-container" v-html="item.icon"></div>
                        {{ item.title }}
                      </RouterLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <router-view v-slot="{ Component, route }">
            <keep-alive>
              <component :is="Component" :key="route.fullPath" />
            </keep-alive>
          </router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import NavbarMain from "@/views/common/navbar-main.vue";
import { RouterLink } from "vue-router";
import { useAuthStore } from "@/stores/user-auth";
import { computed } from "vue";
import { MENU_LIST } from "@/models/menu-list";
import ReloadPWA from "@/components/ReloadPWA.vue";

const auth = useAuthStore();

const menuList = computed(() => {
  let _menu = [];
  for (let item of MENU_LIST) {
    if (auth.permissions.includes(item.permission)) {
      _menu.push(item);
    }
  }
  return _menu;
});
</script>
<style>
html,
body {
  margin: 0;
  padding: 0;
}
.wrap-div {
  height: 100vh;
}
.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
main > .container {
  padding: 15px 15px 0;
}
.border-lg {
  border: 2px solid #f7f7f8 !important;
}
.lv-nav-wrap {
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(57, 69, 124, 0.04);
  border-radius: 32px;
  padding: 32px;
  gap: 8px;
}
.z-index-2 {
  z-index: 2;
}
.nav > [class^="nav-item"]:not(:last-child) {
  margin-right: 12px;
}
.card.card-custom > .card-body {
  padding: 0;
}
.nav.nav-pills .nav-link {
  font-size: 14px;
  line-height: 19.6px;
  text-align: center;
  color: #8f96b8;
  border-radius: 16px;
  min-height: 108px;
}
.nav.nav-pills.nav-info .nav-link.active {
  background-color: #7282cb;
}
.nav.nav-pills.nav-info .nav-link.active {
  margin-right: 0;
  border-radius: 16px !important;
  padding: 24px 8px;
}
.icon-container svg {
  height: 32px;
  width: 32px;
}
.icon-container {
  position: relative;
  height: 32px;
  width: 32px;
}

.icon-svg-active {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  height: 32px;
  width: 32px;
}

.nav.nav-pills.nav-info .nav-link.active .icon-container .icon-svg-active {
  fill: #fff;
  opacity: 1;
}
.nav.nav-pills.nav-info .nav-link.active .icon-container .icon-svg {
  opacity: 0;
}
.icon-svg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.nav.nav-pills.nav-info .nav-link.active {
  margin-right: 0;
  border-radius: 16px !important;
  padding: 24px 8px;
}
.nav > [class^="nav-item"]:not(:last-child) {
  margin-right: 12px;
}
.nav.nav-pills.nav-info .nav-link.active {
  background-color: #7282cb;
}
.nav.nav-pills.nav-info .nav-link:hover:not(.active),
.nav.nav-pills.nav-info .show > .nav-link {
  color: #7282cb;
}
a .icon-svg path {
  fill: #8f96b8;
}
a:hover .icon-svg path {
  fill: #7282cb;
}
@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}
@media (max-width: 768px) {
  .content-background-color {
    z-index: 10;
    padding-top: 12px;
  }
  .subheader-custom h2 {
    color: #7282cb !important;
  }
  .lv-nav-wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    background-color: #f5f9ff;
    border-radius: 0;
    padding: 0;
    gap: 2px;
    box-shadow: 0px 4px 24px rgba(57, 69, 124, 0.05);
  }
  .content {
    padding-bottom: 65px; /* Отступ снизу для футера и меню */
  }

  .lv-nav-wrap.mb-24 {
    margin-bottom: 0;
  }
  .nav.nav-pills.nav-info .nav-link {
    padding: 10px 8px;
    margin-bottom: 0;
  }
  .menu-container {
    overflow-x: auto;
    white-space: nowrap;
  }
  .nav.nav-pills.nav-info .nav-link,
  .nav.nav-pills.nav-info .nav-link.active {
    border-radius: 0 !important;
  }
  .border-lg {
    border: none !important;
  }
  .icon-container {
    position: relative;
    height: 24px;
    width: 24px;
    padding-bottom: 10px;
  }
  .icon-container svg {
    width: 24px;
    height: 24px;
  }
}
</style>
